import config from "./../../common/config";

export const transAPI =
  config.API_BASE +
  "static-assets/build/translations/{{lang}}.json?v={{transVersion}}"; //'constraints/{{lang}}.json'//'static-assets/Translations/{{lang}}.json';//;
export const constraintsAPI =
  config.ACCOUNTS_API_BASE + "feed/gameday-constraints"; //'constraints/constraints_{{tourId}}_{{gameDayId}}.json'// 'static-assets/limits/constraints_1.json';//;
export const fixturesAPI = config.ACCOUNTS_API_BASE + "feed/tour-fixtures"; //'constraints/fixtures.json'//'Feed/fixtures';//;
export const playersAPI = config.ACCOUNTS_API_BASE + "feed/gamedayplayers"; //'constraints/players.json'//'apifeeds/players/playerdetails_1_en.json';//;
export const playersLiveAPI =
  config.ACCOUNTS_API_BASE + "feed/live/gamedayplayers"; //'constraints/players.json'//'apifeeds/players/playerdetails_1_en.json';//;
export const playersCardAPI =
  config.ACCOUNTS_API_BASE +
  "feed/gameday-player/popup-cards?teamId={{team_id}}&playerId={{player_id}}"; //'apifeeds/players/playercarddetails_{{Id}}_1_en.json';//'constraints/players.json';
export const playersCardLiveAPI =
  config.ACCOUNTS_API_BASE +
  "feed/live/gameday-player/popup-cards?teamId={{team_id}}&playerId={{player_id}}";
export const playerStatsAPI =
  config.ACCOUNTS_API_BASE +
  "feed/gameday-player/card-stats?teamId={{team_id}}&playerId={{player_id}}&gamedayId={{gameday_id}}";
export const playerStatsLiveAPI =
  config.ACCOUNTS_API_BASE +
  "feed/live/gameday-player/card-stats?teamId={{team_id}}&playerId={{player_id}}&gamedayId={{gameday_id}}";
export const favTeamAPI =
  config.ACCOUNTS_API_BASE + "feed/tour-teams?lang={{lang}}";
export const userPlayedGamedaysAPI =
  config.ACCOUNTS_API_BASE + "user/{{guid}}/gamedays-get";
export const transferHistoryAPI =
  config.ACCOUNTS_API_BASE + "user/{{guid}}/transfer-history-get";
export const transferHistoryPlayersAPI =
  config.ACCOUNTS_API_BASE +
  "user/{{guid}}/transfer-details-get?teamgamedayId={{gamedayId}}";
export const scorecardApiUrl = config.ACCOUNTS_API_BASE + "feed/score";
export const scorecardLiveApiUrl = config.ACCOUNTS_API_BASE + "live/score";
// sessions
// export const getMyLogin = config.ACCOUNTS_API_BASE + "user/my11-circle-login";
export const getMy11Login = config.ACCOUNTS_API_BASE + "user/validate-token";
// export const postMy11Logout = "/graphql/mutation/pwa/logout-mutation";
export const postMy11Logout = config.ACCOUNTS_API_BASE + "user/my11-logout";

export const postMy11ExtLogout =
  config.LOGOUT_DOMAIN + "my11c/api/fl/account/tokenize/v1/logOutUser";

//services
export const getUserTeamUrl =
  config.ACCOUNTS_API_BASE + "user/{{guid}}/team-get";
export const getUserTeamLiveUrl =
  config.ACCOUNTS_API_BASE + "user/live/{{guid}}/team-get";
export const getRevealedTeamUrl = config.ACCOUNTS_API_BASE + "Unviel/team";
export const postUserTeamAPI = config.ACCOUNTS_API_BASE + "user/team-submit";
export const postLoginAPI = config.ACCOUNTS_API_BASE + "Session/user/login";
export const gdprCookieAPI =
  config.ACCOUNTS_API_BASE + "CookiePolicy/user/accept";
export const getMyTeamListAPI =
  config.ACCOUNTS_API_BASE + "user/{{guid}}/team/overview-get";
export const getMyTeamListLiveAPI =
  config.ACCOUNTS_API_BASE + "user/live/{{guid}}/team/overview-get";
export const getMyTeamListOverallAPI =
  config.ACCOUNTS_API_BASE + "user/guid/lb-team/{{leagueVal}}overall-get";
export const getMyTeamListOverallLiveAPI =
  config.ACCOUNTS_API_BASE + "user/live/guid/lb-team/{{leagueVal}}overall-get";

// contest
export const getPublicContest =
  config.CONTEST_API_BASE + "user/leagues/{{guid}}/public";
export const getLivePublicContest =
  config.CONTEST_API_BASE + "user/leagues/live/{{guid}}/public";
export const getPrivateContest =
  config.CONTEST_API_BASE + "user/leagues/{{guid}}/private";
export const getLivePrivateContest =
  config.CONTEST_API_BASE + "user/leagues/live/{{guid}}/private";
export const postTransferTeamAPI =
  config.ACCOUNTS_API_BASE + "user/transfer-update";
export const postCaptainTeamAPI =
  config.ACCOUNTS_API_BASE + "user/captain-update";
export const postCreateContest =
  config.CONTEST_API_BASE + "user/leagues/create";
export const postJoinContest = config.CONTEST_API_BASE + "user/leagues/join";
export const getContestLeaderboard =
  config.CONTEST_API_BASE + "user/leagues/{{contestId}}/leaderboard";
export const getLiveContestLeaderboard =
  config.CONTEST_API_BASE + "user/leagues/live/{{contestId}}/leaderboard";
export const getContestNewJoinee =
  config.CONTEST_API_BASE + "user/leagues/{{contestId}}/newjoinee";
export const getGlobalLeaderboard =
  config.LEADERBOARD_API_BASE + "leaderboard/global-get";
export const getLiveGlobalLeaderboard =
  config.LEADERBOARD_API_BASE + "leaderboard/live/global-get";
export const getLiveGlobalRank =
  config.LEADERBOARD_API_BASE + "user/live/{{guid}}/global-rank-get";
export const getFavTeamLeaderboard =
  config.LEADERBOARD_API_BASE + "leaderboard/fav-team/{{favteamid}}";
export const getLiveFavTeamLeaderboard =
  config.LEADERBOARD_API_BASE + "leaderboard/live/fav-team/{{favteamid}}";
export const getLiveFavTeamRank =
  config.LEADERBOARD_API_BASE + "user/live/{{guid}}/team-rank-get";
export const getComparisonData =
  config.ACCOUNTS_API_BASE + "user/{{guid}}/compare-team";

export const getCaptainLeaderboard =
  config.LEADERBOARD_API_BASE + "leaderboard/captain";
export const getLiveCaptainLeaderboard =
  config.LEADERBOARD_API_BASE + "leaderboard/live/captain";
export const getLiveCaptainRank =
  config.LEADERBOARD_API_BASE + "user/live/{{guid}}/captain-rank";

export const getViceCaptainLeaderboard =
  config.LEADERBOARD_API_BASE + "leaderboard/vicecaptain";
export const getLiveViceCaptainLeaderboard =
  config.LEADERBOARD_API_BASE + "leaderboard/live/vicecaptain";
export const getLiveViceCaptainRank =
  config.LEADERBOARD_API_BASE + "user/live/{{guid}}/vicecaptain-rank";

export const getKnockoutLeaderboard =
  config.LEADERBOARD_API_BASE + "leaderboard/knockout-get";
export const getLiveKnockoutLeaderboard =
  config.LEADERBOARD_API_BASE + "leaderboard/live/knockout-get";
export const getLiveKnockoutRank =
  config.LEADERBOARD_API_BASE + "user/live/{{guid}}/knockout-rank-get";

//Stats
export const playerStatisticsAPI =
  config.ACCOUNTS_API_BASE + "feed/tour-player/stats";
export const playerStatisticsLiveAPI =
  config.ACCOUNTS_API_BASE + "feed/live/tour-player/stats";
export const getOtherUserTeamUrl =
  config.ACCOUNTS_API_BASE + "user/guid/lb-team-get";
export const getOtherUserTeamLiveUrl =
  config.ACCOUNTS_API_BASE + "user/live/guid/lb-team-get";

//GamerCard
export const gamerCardAPI =
  config.ACCOUNTS_API_BASE +
  "user/{{guid}}/game-card-get?optType={{opttype}}&platformId={{platformId}}&clientId={{clientId}}";
export const mixAPI = config.ACCOUNTS_API_BASE + "live/mixapi";

export const userPtsHistory =
  config.ACCOUNTS_API_BASE +
  "user/{{guid}}/gameday-points-get?optType={{opttype}}";
// STATS WIDGET
export const widgetAPI =
  config.ACCOUNTS_API_BASE +
  "feed/tour-player/match-center-widget?lang={{lang}}";
export const widgetLiveAPI =
  config.ACCOUNTS_API_BASE +
  "feed/live/tour-player/match-center-widget?lang={{lang}}";

// USER STATS
export const userStatsAPI =
  config.ACCOUNTS_API_BASE + "user/{{guid}}/gamedays/status-get";

export const boostersConAPI = config.ACCOUNTS_API_BASE + "feed/boosterslist";

export const BadgesAPI =
  config.ACCOUNTS_API_BASE + "feed/badgeslist?v={{version}}";
export const removeLeagueAPI =
  config.ACCOUNTS_API_BASE + "user/leagues/disjoinadmin";
export const leaveLeagueAPI = config.ACCOUNTS_API_BASE + "user/leagues/disjoin";
// USER BADGES
export const UserBadgesAPI =
  config.ACCOUNTS_API_BASE + "user/{{guid}}/userbadge-get";
export const userbadgemasterAPI =
  config.ACCOUNTS_API_BASE + "user/{{guid}}/userbadgemaster-get";

// POST BADGE NOTIFY
export const postBadgeNotifyAPI =
  config.ACCOUNTS_API_BASE + "user/{{guid}}/badgenotify-update";

export const akamaiTimeURL = config.serverApiUrl;

// MY PROFILE CHANGES

export const countryFavStatic = config.STATIC_API + "select.json";

export const teamNamePostApi =
  config.ACCOUNTS_API_BASE + "user/teamname-update";
export const profileUpdatePostApi =
  config.ACCOUNTS_API_BASE + "user/profile-update";
export const profileGetApi = config.ACCOUNTS_API_BASE + "user/{{guid}}/profile";
export const configApi = config.STATIC_API + "config.json?v={{version}}";

const objUrl = {
  playersAPI: playersAPI,
  getUserTeamUrl: getUserTeamUrl,
  getOtherUserTeamUrl: getOtherUserTeamUrl,
  getMyTeamListAPI: getMyTeamListAPI,
  getMyTeamListOverallAPI: getMyTeamListOverallAPI,
  playerStatsAPI: playerStatsAPI,
  playersCardAPI: playersCardAPI,
};
export default objUrl;
